<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="会计年度">
              <a-input placeholder="请输入年度" v-model="queryParam.fyear"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="期间">
              <a-input placeholder="请输入期间" v-model="queryParam.fperiod"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="账簿">
              <a-input placeholder="账簿" v-model="queryParam.faccountBook"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span style="margin-right: 60px;">币别：{{fcurrencyName}}</span>
        <span style="margin-right: 60px;">账簿：{{faccountBook}}</span>
        <span style="margin-right: 60px;">期间：{{fYearPeriod}}</span>
        <span style="float:right; ">金额单位：元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <!--<span slot="action" slot-scope="text, record">-->
          <!--<a @click="handleEdit(record)">编辑</a>-->

          <!--<a-divider type="vertical" />-->
          <!--<a-dropdown>-->
            <!--<a class="ant-dropdown-link">更多 <a-icon type="down" /></a>-->
            <!--<a-menu slot="overlay">-->
              <!--<a-menu-item>-->
                <!--<a @click="handleDetail(record)">详情</a>-->
              <!--</a-menu-item>-->
              <!--<a-menu-item>-->
                <!--<a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
                  <!--<a>删除</a>-->
                <!--</a-popconfirm>-->
              <!--</a-menu-item>-->
            <!--</a-menu>-->
          <!--</a-dropdown>-->
        <!--</span>-->

      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'BizFinancialBalanceList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '科目余额表',
        fcurrencyName: '人民币',
        faccountBook:'',
        fYearPeriod:'',
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title:'科目编码',
            className: 'column-text',
            dataIndex: 'faccountNumber',
            sort: true,
          },
          {
            title:'科目名称',
            className: 'column-text',
            dataIndex: 'faccountName'
          },
          {
            title:'核算维度编码',
            className: 'column-text',
            dataIndex: 'fdetailNumber'
          },
          {
            title:'核算维度名称',
            className: 'column-text',
            dataIndex: 'fdetailName'
          },
          {
            title:'期初借方余额',
            className: 'column-money',
            dataIndex: 'fbeginBalanceDebit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'期初贷方余额',
            className: 'column-money',
            dataIndex: 'fbeginBalanceCredit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'本期借方发生',
            className: 'column-money',
            dataIndex: 'fdebit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'本期贷方发生',
            className: 'column-money',
            dataIndex: 'fcredit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'本年借方累计',
            className: 'column-money',
            dataIndex: 'fytdDebit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'本年贷方累计',
            className: 'column-money',
            dataIndex: 'fytdCredit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'期末借方余额',
            className: 'column-money',
            dataIndex: 'fendBanlanceDebit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          {
            title:'期末贷方余额',
            className: 'column-money',
            dataIndex: 'fendBanlanceCredit',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:147,
          //   scopedSlots: { customRender: 'action' }
          // }
        ],
        isorter: {
          column: 'faccountNumber',
          order: 'asc'
        },
        url: {
          list: "/bms/bizFinancialBalance/list",
          //delete: "/bms/bizFinancialBalance/delete",
          //deleteBatch: "/bms/bizFinancialBalance/deleteBatch",
          //exportXlsUrl: "/bms/bizFinancialBalance/exportXls",
          importExcelUrl: "bms/bizFinancialBalance/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      //初始加载数据后会被调用
      afterLoadData(){
        if(this.dataSource.length >0){
          let source = this.dataSource[0];
          this.faccountBook = source.faccountBook;
          this.fYearPeriod = source.fyear + '-' + source.fperiod;
          this.fcurrencyName = source.fcurrencyName;
        } else{
          this.faccountBook = "";
          this.fYearPeriod = "";
          this.fcurrencyName = "";
        }
      }
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>